import React, { useState, useEffect, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import { Link } from "react-router-dom";
import "./Services.css";
import BackToTop from "./BackToTop";
import ButtonZap from "../components/ButtonZap";
import Title from "../styled-components/Title";
import Paragraph from "../styled-components/Paragraph";

function Services() {
  const [inProp, setInProp] = useState(false);
  const listRef = useRef(null);
  const [pageCount, setPageCount] = useState(0);
  const [current, setCurrent] = useState(0);

  useEffect(() => setInProp(true), []);

  useEffect(() => {
    if (!inProp) return;
    const el = listRef.current;
    if (!el) return;

    const update = () => {
      const items = el.querySelectorAll(":scope > div").length;
      setPageCount(items);
      const w = el.clientWidth || 1;
      setCurrent(Math.round((el.scrollLeft || 0) / w));
    };

    const ro = new ResizeObserver(update);
    ro.observe(el);

    const onScroll = () => {
      const w = el.clientWidth || 1;
      setCurrent(Math.round(el.scrollLeft / w));
    };

    el.addEventListener("scroll", onScroll, { passive: true });
    update();

    return () => {
      ro.disconnect();
      el.removeEventListener("scroll", onScroll);
    };
  }, [inProp]);

  const goTo = (i) => {
    const el = listRef.current;
    if (!el) return;
    const w = el.clientWidth || 0;
    el.scrollTo({ left: i * w, behavior: "smooth" });
    setCurrent(i);
  };

  return (
    <div className="Services">
      <CSSTransition in={inProp} timeout={400} classNames="fade" unmountOnExit>
        <main className="svc-main">
          <div className="svc-header">
            <Title>Serviços e Soluções</Title>
          </div>

          <div id="main-div-services" ref={listRef}>
            {/* Guarda de Documentos */}
            <div>
              <Link to="/documents">
                <div className="emoji">📦</div>
                <Paragraph>Guarda de Documentos</Paragraph>
                <button className="svc-cta glow-btn">
                  Saiba mais <span className="arrow">→</span>
                </button>
              </Link>
            </div>

            {/* Digitalização */}
            <div>
              <Link to="/scanning">
                <div className="emoji">🖨️</div>
                <Paragraph>Digitalização de Documentos</Paragraph>
                <button className="svc-cta glow-btn">
                  Saiba mais <span className="arrow">→</span>
                </button>
              </Link>
            </div>

            {/* Sistema RH Digital */}
            <div>
              <Link to="/RH">
                <div className="emoji">👨🏻‍💼</div>
                <Paragraph>Sistema RH Digital</Paragraph>
                <button className="svc-cta glow-btn">
                  Saiba mais <span className="arrow">→</span>
                </button>
              </Link>
            </div>

            {/* BPO */}
            <div>
              <Link to="/BPO">
                <div className="emoji">⚙️</div>
                <Paragraph>BPO - Terceirização de Processos</Paragraph>
                <button className="svc-cta glow-btn">
                  Saiba mais <span className="arrow">→</span>
                </button>
              </Link>
            </div>

            {/* Assinatura Digital */}
            <div>
              <Link to="/signature">
                <div className="emoji">🖋️</div>
                <Paragraph>Assinatura Digital</Paragraph>
                <button className="svc-cta glow-btn">
                  Saiba mais <span className="arrow">→</span>
                </button>
              </Link>
            </div>

            {/* Mapeamento de Sistemas */}
            <div>
              <Link to="https://www.uaify.io/" target="_blank" rel="noreferrer">
                <div className="emoji">🖥️</div>
                <Paragraph>Mapeamento de Sistemas</Paragraph>
                <button className="svc-cta glow-btn">
                  Saiba mais <span className="arrow">→</span>
                </button>
              </Link>
            </div>
          </div>

          {/* Dots */}
          {pageCount > 1 && (
            <div className="svc-dots" aria-label="Navegação dos cards">
              {Array.from({ length: pageCount }).map((_, i) => (
                <button
                  key={i}
                  className={`dot ${i === current ? "active" : ""}`}
                  onClick={() => goTo(i)}
                  aria-current={i === current ? "true" : "false"}
                />
              ))}
            </div>
          )}
        </main>
      </CSSTransition>

      <BackToTop />
      <ButtonZap />
    </div>
  );
}

export default Services;
